import { regionOptions, sortOptions, typeOptions, yearOptions } from '@/mocks/movies';

export interface CategoryFilters {
  type: string;
  region: string;
  year: string;
  sort: string;
}

interface FilterSidebarProps {
  filters: CategoryFilters;
  onChange: (patch: Partial<CategoryFilters>) => void;
  onReset: () => void;
  resultCount: number;
}

function FilterGroup({
  label,
  options,
  value,
  onSelect,
}: {
  label: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div>
      <h3 className="font-heading text-sm font-semibold text-foreground-950">{label}</h3>
      <div className="mt-3 flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onSelect(option)}
            className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition-colors ${
              value === option
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterSidebar({ filters, onChange, onReset, resultCount }: FilterSidebarProps) {
  return (
    <div className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <i className="ri-filter-3-line text-lg text-primary-600"></i>
          <h2 className="font-heading text-base font-bold text-foreground-950">筛选条件</h2>
        </div>
        <button
          type="button"
          onClick={onReset}
          className="cursor-pointer whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs font-medium text-secondary-700 transition-colors hover:bg-secondary-100"
        >
          重置筛选
        </button>
      </div>

      <p className="mt-3 text-xs text-foreground-500">
        已筛选出 <span className="font-semibold text-accent-600">{resultCount}</span> 部作品
      </p>

      <div className="mt-5 space-y-6">
        <FilterGroup
          label="内容类型"
          options={typeOptions}
          value={filters.type}
          onSelect={(v) => onChange({ type: v })}
        />
        <FilterGroup
          label="地区"
          options={regionOptions}
          value={filters.region}
          onSelect={(v) => onChange({ region: v })}
        />
        <FilterGroup
          label="年份"
          options={yearOptions}
          value={filters.year}
          onSelect={(v) => onChange({ year: v })}
        />
        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950">排序方式</h3>
          <div className="mt-3 flex flex-col gap-2">
            {sortOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => onChange({ sort: option.value })}
                className={`flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm transition-colors ${
                  filters.sort === option.value
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-secondary-100'
                }`}
              >
                {option.label}
                {filters.sort === option.value && <i className="ri-check-line"></i>}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}